import React from "react";
import { LogoutOutlined, SettingOutlined, UserOutlined, MenuOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Layout, MenuProps, Space, Typography, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { AUTH_LOGIN, PROFILE } from "../../assets/constants/route_path";
import { IUser } from "../../models/user.model";
import { LogoutType } from "../../models/logout.model";
import { useWindowSize } from "../../hook";

type HeaderProps = {
    profile?: IUser;
    collapsed: boolean;
    isMobile?: boolean;
    onMobileMenuToggle?: () => void;
};

const newHeaderMenuItems = ({
    onLogoutCb,
    navigateCb,
}: {
    onLogoutCb: () => void;
    navigateCb: any;
}): MenuProps["items"] => {
    return [
        {
            key: "1",
            onClick: () => navigateCb(PROFILE),
            label: (
                <Space>
                    <UserOutlined />
                    <span>Trang cá nhân</span>
                </Space>
            ),
        },
        {
            key: "2",
            onClick: onLogoutCb,
            label: (
                <Space>
                    <LogoutOutlined />
                    <span>Đăng xuất</span>
                </Space>
            ),
        },
    ];
};

const LayoutHeader: React.FunctionComponent<HeaderProps> = (props) => {
    const { profile, collapsed, isMobile, onMobileMenuToggle } = props
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const handleLogout = async () => {
        await dispatch(logout({ logoutType: LogoutType.USER_LOGOUT })).unwrap()
        navigate(AUTH_LOGIN, { replace: true });
    };
    const size = useWindowSize()
    const widthMenu = isMobile ? 0 : (collapsed ? 80 : 250)

    return (
        <Layout.Header
            style={{
                backgroundColor: "white",
                borderBottom: "1px solid rgba(5, 5, 5, 0.06)",
                paddingLeft: isMobile ? 12 : 12,
                paddingRight: 20,
                height: 64,
                position: 'fixed',
                zIndex: 1000,
                width: isMobile ? '100%' : size.width - widthMenu,
                left: isMobile ? 0 : widthMenu,
                transition: 'all 0.3s ease'
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: isMobile ? "space-between" : "flex-end",
                    alignItems: "center",
                    height: "100%"
                }}
            >
                {/* Mobile menu button */}
                {isMobile && (
                    <Button
                        type="text"
                        icon={<MenuOutlined />}
                        onClick={onMobileMenuToggle}
                        style={{
                            border: 'none',
                            color: '#fa5d67',
                            fontSize: '18px',
                            width: '48px',
                            height: '48px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '8px',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(250, 93, 103, 0.1)';
                            e.currentTarget.style.transform = 'scale(1.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    />
                )}

                <Dropdown
                    menu={{
                        items: newHeaderMenuItems({
                            onLogoutCb: handleLogout,
                            navigateCb: navigate,
                        }),
                    }}
                    trigger={["click"]}
                    overlayStyle={{ width: "200px", height: "200px" }}
                >
                    <Space style={{ cursor: "pointer" }}>
                        <>
                            <Typography.Text strong>
                                Chào, {profile?.username}
                            </Typography.Text>
                        </>
                        <Avatar icon={<SettingOutlined />} />
                    </Space>
                </Dropdown>
            </div>
        </Layout.Header>
    );
};

export default LayoutHeader;
